import React from "react";

import FormAction from "../../../../../components/common/FormAction";
import RightBar from "../../../../../components/common/RightBar";

import { Card, Col, DatePicker, Form, Input, Row, Select } from "antd";

import { propertiesunitscampaigns } from "../../../../../data/guestcards";

import "./UtilityBillDetails.css";

const UtilityBillDetailsRightBar = [];

function UtilityBillDetails() {
  return (
    <>
      <div className="utility-bill-details">
        <Card title="Utility Bill Details">
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 11 }} colon={false}>
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Row gutter={[0, 16]}>
                  <Col span={24}>
                    <p>
                      This feature allocates utility bills using RUBS, which can
                      be set up on the property page.
                    </p>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[24, 0]}>
                      <Col span={12}>
                        <Row>
                          <Col span={24}>
                            <Form.Item label="Property" required>
                              <Select options={propertiesunitscampaigns} />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Vendor">
                              <p>--</p>
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Reference">
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Remarks">
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Memo on Check">
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Vendor Bill GL">
                              <p>--</p>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <Row>
                          <Col span={24}>
                            <Form.Item label="Utility" required>
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Vendor" required>
                              <DatePicker />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Reference" required>
                              <DatePicker />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Remarks" required>
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Memo on Check" required>
                              <Select
                                options={[
                                  { value: "automatic" },
                                  { value: "rental" },
                                  { value: "security" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <hr />
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={24}>
                    <Row gutter={[24, 0]}>
                      <Col span={12}>
                        <Row>
                          <Col span={24}>
                            <Form.Item label="Tenant Charge Date" required>
                              <DatePicker />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="Consumtion From" required>
                              <DatePicker />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <Row>
                          <Col span={24}>
                            <Form.Item label="Tenant Charge GL">
                              <p>--</p>
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item label="To">
                              <DatePicker />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <FormAction btnText="Create Bill and Charges" />
              </Col>
            </Row>
          </Form>
        </Card>
      </div>

      <div className="RightSidebar">
        <RightBar RightBarData={UtilityBillDetailsRightBar} />
      </div>
    </>
  );
}

export default UtilityBillDetails;
